import api from "../api/axios";

const API_URL = "permissions";

export const getUserPermissions = (roleId, company_id,plan_id) => {
  return api
    .get(`${API_URL}`, { params: { roleId, company_id , plan_id} })
    .then((response) => response.data)
    .catch((error) => {
      console.error("Error fetching permissions:", error);
      throw error;
    });
};
